/**
 * Store для состояния устройства
 */
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface DeviceState {
  deviceId: string | null
  deviceSecret: string | null
  siteId: string | null
  isRegistered: boolean
  
  setDevice: (deviceId: string, deviceSecret: string) => void
  setSiteId: (siteId: string) => void
  setDeviceId: (deviceId: string) => void  // Для установки device_id без секрета
  clearDevice: () => void
}

export const useDeviceStore = create<DeviceState>()(
  persist(
    (set) => ({
      deviceId: null,
      deviceSecret: null,
      siteId: null,
      isRegistered: false,
      
      setDevice: (deviceId: string, deviceSecret: string) =>
        set({ deviceId, deviceSecret, isRegistered: true }),
      
      setSiteId: (siteId: string) => set({ siteId }),
      
      setDeviceId: (deviceId: string) => set({ deviceId }),
      
      clearDevice: () =>
        set({
          deviceId: null,
          deviceSecret: null,
          siteId: null,
          isRegistered: false,
        }),
    }),
    {
      name: 'device-storage',
    }
  )
)

